import { HbrAvatarProfile } from "./newComponents/Mycustomsvgicons";

const HomePreloaders = ({actionshare,actionPic,height}) => {
    const divs = [];
    for (let i = 0; i < 10; i++) {
      divs.push(

        <div className="fetchingfrontpagebooks" key={i} style={{height:"100%"}}>
            {actionPic === "show" && 
            <div style={{
                position:"absolute",
                top:"1em",
                left:"1em"
            }}>
                 <HbrAvatarProfile width="2em" height="2em" />
            </div>
            }

            {actionshare === "show" ? 
                   <div className="flex-spacebetween" style={{width:"100%", position:"absolute",top:"80%"}}>
                        <button style={{
                            border:"none",
                            borderRadius:"10px",
                            backgroundColor:"#1C1F2E30",
                            color:"transparent",
                            padding:"10px"
                            }}>
                            Clone
                        </button>

                        <button style={{
                            border:"none",
                            borderRadius:"50%",
                            backgroundColor:"#1C1F2E30",
                            color:"transparent",
                            padding:"10px"
                            }}>
                                Clone
                        </button>
                  </div>
                  :
                  <button style={{
                    border:"none",
                    borderRadius:"10px",
                    backgroundColor:"#1C1F2E50",
                    color:"transparent",
                    position:"absolute",
                    top:"80%",
                    padding:"10px"
                    }}>
                      Clone
                </button>
            }
      
        </div>
      );
    
    };


    return divs;
     
}
export default HomePreloaders;